"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocsGlobalHelpBody = DocsGlobalHelpBody;
var _react = _interopRequireDefault(require("react"));
var _fp = require("lodash/fp");
var _mdiMaterialUi = require("mdi-material-ui");
var _core = require("@material-ui/core");
var _TextField = _interopRequireDefault(require("../../TextField/TextField"));
var _DocsGlobalHelp = _interopRequireDefault(require("../DocsGlobalHelp.styles"));
var _useClickHelpSearch2 = require("../hooks/useClickHelpSearch");
var _SearchResult = require("./SearchResult");
var _NoResults = require("./NoResults");
var _Error = require("./Error");
var _Loading = require("./Loading");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function DocsGlobalHelpBody(_ref) {
  var onClose = _ref.onClose;
  var classes = (0, _DocsGlobalHelp.default)();
  var _useClickHelpSearch = (0, _useClickHelpSearch2.useClickHelpSearch)(),
    isLoading = _useClickHelpSearch.isLoading,
    error = _useClickHelpSearch.error,
    data = _useClickHelpSearch.data,
    onSearch = _useClickHelpSearch.onSearch;
  var debouncedFetchClickHelpSearch = (0, _fp.debounce)(500, onSearch);
  var handleSearch = function handleSearch(e) {
    var searchTerm = e.target.value.trim();
    // eslint-disable-next-line no-void
    void debouncedFetchClickHelpSearch(searchTerm);
  };
  var content = /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spacer
  });
  if (error) {
    content = /*#__PURE__*/_react.default.createElement(_Error.Error, null);
  } else if (isLoading) {
    content = /*#__PURE__*/_react.default.createElement(_Loading.Loading, null);
  } else if (data && data.length === 0) {
    content = /*#__PURE__*/_react.default.createElement(_NoResults.NoResults, null);
  } else if (data) {
    content = /*#__PURE__*/_react.default.createElement("div", {
      className: classes.resultsContainer
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: classes.resultsHeader
    }, "Top Results (", data.length, ")"), /*#__PURE__*/_react.default.createElement("ul", {
      className: classes.resultsList
    }, data === null || data === void 0 ? void 0 : data.map(function (result) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: classes.resultListItem,
        key: result.id
      }, /*#__PURE__*/_react.default.createElement(_SearchResult.SearchResult, result));
    })));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.HelpCircle, {
    className: classes.titleIcon
  }), /*#__PURE__*/_react.default.createElement("h2", {
    className: classes.title
  }, "Tackle Help"), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: classes.closeButton,
    onClick: onClose,
    disableRipple: true
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Close, {
    className: classes.closeIcon
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/_react.default.createElement(_TextField.default, {
    name: "tackle-global-help-search",
    id: "outlined-search",
    placeholder: "Search Tackle Docs",
    iconLeft: /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Magnify, {
      className: classes.searchIcon
    }),
    onChange: handleSearch,
    autoFocus: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentContainer
  }, content));
}